import React, { useState, useEffect } from 'react'
import '../assets/css/rightSideBar.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faAngleLeft, faHouse, faAddressCard, faToolbox, faCode, faRocket, faBusinessTime, faFile, faNewspaper, faAddressBook } from '@fortawesome/free-solid-svg-icons';
import MenuButton from './MenuButton'

import { useLocation, Link } from 'react-router-dom';
{/*
<i class="fa-solid fa-rocket"></i>
<i class="fa-solid fa-code"></i>

<i class="fa-solid fa-award"></i>
<i class="fa-solid fa-handshake"></i>
<i class="fa-solid fa-business-time"></i>
<i class="fa-solid fa-people-group"></i>

<i class="fa-solid fa-file"></i>

<i class="fa-solid fa-newspaper"></i>

<i class="fa-solid fa-address-book"></i>

*/}



const RightSideBar = () => {
    const [isSlideRight, setSlideRight] = useState(false)
    const [isHover, setIsHover] = useState(false)
    const [active, setActive] = useState("/");
    const location = useLocation();

    const handelSlideButtonClick = () => {
        setSlideRight(!isSlideRight)
    }
    const handelIsHover = () => {
        setIsHover(!isHover)
    }

    useEffect(() => {
        const currentPage = location.pathname.split('/').pop();
        setActive(currentPage)
    }, [location.pathname]);

    return (
        <div className={`sidebar_container ${isSlideRight ? 'slide_right' : ''}`}>
            <div className="sidebar_sub_container1">
                {/* need to add tooltipe for "Close Sidebar" and "Open Sidebar"  */}
                <div className={`slide_btn`} onClick={handelSlideButtonClick} onMouseEnter={handelIsHover} onMouseLeave={handelIsHover} >
                    <span className="menu_btn_label_container">
                        <span className={"menu_btn_label"}> {isSlideRight ? "Open Sidebar" : "Close Sidebar"}</span>
                    </span>
                    {isSlideRight ? <FontAwesomeIcon icon={faAngleLeft} /> : (isHover ? <FontAwesomeIcon icon={faAngleRight} /> : <div className="pipe"></div>)}</div>
            </div>
            <div className="sidebar_sub_container2">

                <MenuButton to={"/"} icon={faHouse} label={"Home"} isActive={active == "" ? true : false} /> {/*  Home */}

                <MenuButton to={"/about"} icon={faAddressCard} label={"About"} isActive={active == "about" ? true : false} /> {/* About Me  */}

                <MenuButton to={"/skills"} icon={faToolbox} label={"Skills"} isActive={active == "skills" ? true : false} /> {/*  Skills */}

                <MenuButton to={"/projects"} icon={faRocket} label={"Projects"} isActive={active == "projects" ? true : false} /> {/* Projects  */}

                <MenuButton to={"/experience"} icon={faBusinessTime} label={"Experienc"} isActive={active == "experience" ? true : false} /> {/* Experience  */}

                <MenuButton to={"/resume"} icon={faFile} label={"Resume"} isActive={active == "resume" ? true : false} /> {/* Resume  */}

                <MenuButton to={"/blogs"} icon={faNewspaper} label={"Blogs"} isActive={active == "blogs" ? true : false} /> {/* Blogs  */}

                <MenuButton to={"/contact"} icon={faAddressBook} label={"Contact"} isActive={active == "contact" ? true : false} /> {/* Contact  */}

            </div>
        </div>
    )

}

export default RightSideBar